var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-section"},[_c('div',{staticClass:"tags"},[_c('i',{class:_vm.tagIcon}),_c('label',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.tagHeading)))])]),_c('div',{staticClass:"tag-status"},[_c('span',{class:_vm.tagStatusClass},[_c('i',{class:_vm.tagStatusIcon})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }